module.exports = __webpack_public_path__ + "static/media/register.80af570f.svg";